import request from '@/utils/request'
const url = 'admin/Writeoff'
const api = {
  // 获取核销码信息
  getWriteOff(data) {
    return request({
      url: `${url}/getWriteOff`,
      method: 'post',
      data
    })
  },
  WriteCode(data) {
    return request({
      url: `${url}/WriteCode`,
      method: 'post',
      data
    })
  }
}

export default api
